import { createContext, useState } from "react"
type contextType={
    children :React.ReactNode
}
type MagasinType={
    id:number,
    image:string,
    name:string,
    email:string, 
    list:any,
    adresse:any

    magasinCommercial:any,
    SoldeCommercial : any,
    setSoldeCommercial: any,
    TeleCommecrial:any,
    setTeleCommecrial:any,

}
type MagasinContextType={
    id:any , 
    magasinCommercial:any
    setmagasinCommercial:any
    setId:any,
    image:any , 
    setImage:any,
    nameMagasin:any,
    setNameMagasin:any,
    setadresse:any,
    email:any, 
    setEmail:any,
    list:any,
    setList:any,
    adresse:any,
    SoldeCommercial : any,
    setSoldeCommercial: any,
    TeleCommecrial:any,
    setTeleCommecrial:any,
}
export const MagasinContext = createContext({} as MagasinContextType);

export const  UserContextProvider = ({children}:contextType)=>{
    const [id , setId] = useState<MagasinType | null>(null);
    const [image , setImage] = useState<MagasinType | null>(null);
    const [nameMagasin , setNameMagasin] = useState<MagasinType | null>(null);
    const [email , setEmail] = useState<MagasinType | null>(null);
    const [list , setList] = useState<any>("");
    const [adresse , setadresse] = useState<MagasinType | null>(null);
    const [magasinCommercial , setmagasinCommercial] = useState<MagasinContextType|null>(null);
    const [TeleCommecrial , setTeleCommecrial] = useState<MagasinContextType|null>(null);
    const [SoldeCommercial , setSoldeCommercial] = useState<MagasinContextType|null>(null);






    return(

        <MagasinContext.Provider value={{
            id , setId,TeleCommecrial ,setTeleCommecrial, SoldeCommercial,setSoldeCommercial ,magasinCommercial , setmagasinCommercial, image ,adresse , setadresse, setImage , email , setEmail , nameMagasin , setNameMagasin , list , setList}}>{children}</MagasinContext.Provider>
    )
}